import request from '@/utils/request'




// 业务员提现记录
export function ywwithdrawRecordList(data) {
  return request({
    url: '/admin/ywWithdrawRecord/list',
    method: 'post',
    data
  })
}
export function ywtotalAmount(data) {
  return request({
    url: '/admin/ywWithdrawRecord/totalAmount',
    method: 'post',
    data
  })
}

export function teamLevelConfigList(data) {
  return request({
    url: '/admin/teamLevelConfig/list',
    method: 'post',
    data
  })
}
export function teamLevelConfigUpdate(data) {
  return request({
    url: '/admin/teamLevelConfig/update',
    method: 'post',
    data
  })
}

export function memberSubsidyZhuan(data) {
  return request({
    url: '/admin/memberSubsidy/zhuanList',
    method: 'post',
    data
  })
}

export function memberSubsidyList(data) {
  return request({
    url: '/admin/memberSubsidy/list',
    method: 'post',
    data
  })
}
export function setIsSubsidy(data) {
  return request({
    url: '/admin/member/setIsSubsidy',
    method: 'post',
    data
  })
}
export function ywautoShenhe(data) {
  return request({
    url: '/admin/ywWithdrawRecord/autoShenhe',
    method: 'post',
    data
  })
} 
export function ywupdateAutoShenhe(data) {
  return request({
    url: '/admin/ywWithdrawRecord/updateAutoShenhe',
    method: 'post',
    data
  })
}
export function ywapplyCount(data) {
  return request({
    url: '/admin/ywWithdrawRecord/applyCount',
    method: 'post',
    data
  })
}
export function withdrawTransferBnbResetStatus(data) {
  return request({
    url: '/admin/memberShareWithdrawBnb/resetStatus',
    method: 'post',
    data
  })
}
export function zhuanList(data) {
  return request({
    url: '/admin/memberShareWithdrawBnb/zhuanList',
    method: 'post',
    data: data
  })
}
export function masterAccounts(data) {
  return request({
    url: '/admin/memberShareWithdrawBnb/masterAccounts',
    method: 'post',
    data: data
  })
}
export function memberShareWithdrawBnbRejectList(data) {
  return request({
    url: '/admin/memberShareWithdrawBnb/rejectList',
    method: 'post',
    data: data
  })
}
export function withdrawTransfer(data) {
  return request({
    url: '/admin/memberShareWithdrawBnb/list',
    method: 'post',
    data: data
  })
}
export function memberShareWithdrawTrxTesetStatus(data) {
  return request({
    url: '/admin/memberShareWithdrawTrx/resetStatus',
    method: 'post',
    data
  })
}
export function zhuanListTrx(data) {
  return request({
    url: '/admin/memberShareWithdrawTrx/zhuanList',
    method: 'post',
    data: data
  })
}
export function memberShareWithdrawTrx(data) {
  return request({
    url: '/admin/memberShareWithdrawTrx/list',
    method: 'post',
    data: data
  })
}
export function masterAccountsTrx(data) {
  return request({
    url: '/admin/memberShareWithdrawTrx/masterAccounts',
    method: 'post',
    data: data
  })
}
export function memberShareWithdrawTrxRejectList(data) {
  return request({
    url: '/admin/memberShareWithdrawTrx/rejectList',
    method: 'post',
    data: data
  })
}
export function approveStatus1and(data) {
    return request({
      url: '/admin/memberShareRecord/approveStatus1and2',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    })
  }
export function memberVipRecord(data) {
    return request({
      url: '/admin/memberVipRecord/list',
      method: 'post',
      data
    })
  }
  export function adDomainData(data) {
    return request({
      url: '/admin/adDomainData/list',
      method: 'post',
      data
    })
  }
  export function entranceConfig(data) {
    return request({
      url: '/admin/entranceConfig/view',
      method: 'post',
      data
    })
  }
   export function approveStage(data) {
    return request({
      url: '/admin/memberShareRecord/approveStage4',
      method: 'post',
      data
    })
  }
  export function entranceConfigUpdate(data) {
    return request({
      url: '/admin/entranceConfig/update',
      method: 'post',
      data
    })
  }
// 闪兑记录
export function memberExchangeRecord(data) {
  return request({
    url: '/admin/memberExchangeRecord/list',
    method: 'post',
    data
  })
}
export function memberTradeCoinRecord(data) {
  return request({
    url: '/admin/memberTradeCoinRecord/list',
    method: 'post',
    data
  })
}
// 抽奖设置
 // 抽奖配置
 export function drawConfigList(data) {
  return request({
    url: '/admin/drawConfig/list',
    method: 'post',
    data
  })
}
export function drawConfigSave(data) {
  return request({ 
    url: '/admin/drawConfig/save',
    method: 'post',
    data
  })
}
export function drawConfigUpdate(data) {
  return request({
    url: '/admin/drawConfig/update',
    method: 'post',
    data
  })
}
export function drawConfigDelete(data) {
  return request({
    url: '/admin/drawConfig/delete',
    method: 'post',
    data
  })
}


// 通用内容配置
  export function commonContentList(data) {
    return request({
      url: '/admin/commonContent/list',
      method: 'post',
      data
    })
  }
  export function commonContentUpdate(data) {
    return request({
      url: '/admin/commonContent/update',
      method: 'post',
      data
    })
  }
  export function commonContentSave(data) {
    return request({
      url: '/admin/commonContent/save',
      method: 'post',
      data
    })
  }
  export function commonContentDelete(data) {
    return request({
      url: '/admin/commonContent/delete',
      method: 'post',
      data
    })
  }
  // 充值记录
  export function tronsCanTransferList(data) {
    return request({
      url: '/admin/tronscanTransfer/list',
      method: 'post',
      data
    })
  }
  export function totalRecharge(data) {
    return request({
      url: '/admin/tronscanTransfer/totalRecharge',
      method: 'post',
      data
    })
  }
  export function tronscanTransferOtherList(data) {
    return request({
      url: '/admin/tronscanTransferOther/list',
      method: 'post',
      data
    })
  }
  export function tronscanTransferOther(data) {
    return request({
      url: '/admin/tronscanTransferOther/totalRecharge',
      method: 'post',
      data
    })
  }
  // 代理商管理
  export function yiFangList(data) {
    return request({
      url: '/admin/yifang/list',
      method: 'post',
      data
    })
  }
  export function yiFangSave(data) {
    return request({
      url: '/admin/yifang/save',
      method: 'post',
      data
    })
  }
  export function yiFangUpdate(data) {
    return request({
      url: '/admin/yifang/update',
      method: 'post',
      data
    })
  }
  // 签到
  export function signConfigList(data) {
    return request({
      url: '/admin/signConfig/list',
      method: 'post',
      data
    })
  }
  export function signConfigSave(data) {
    return request({
      url: '/admin/signConfig/save',
      method: 'post',
      headers: { 
        "Content-Type": "application/json"
      },
      data
    })
  }
  export function signConfigUpdate(data) {
    return request({
      url: '/admin/signConfig/update',
      method: 'post',
      headers: {
        "Content-Type": "application/json"
      },
      data
    })
  }
  export function signConfigDelete(data) {
    return request({
      url: '/admin/signConfig/delete',
      method: 'post',
      data
    })
  }
    // 代理商数据
    export function yifangData(data) {
      return request({
        url: '/admin/yifangData/data',
        method: 'post',
        data
      })
    }
    export function dataToday(data) {
      return request({
        url: '/admin/yifangData/dataToday',
        method: 'post',
        data
      })
    }
    export function yiFangDetail(data) {
      return request({
        url: '/admin/yifangData/detail',
        method: 'post',
        data
      })
    }
    // 轮播图
    export function bannerList(data) {
      return request({
        url: '/admin/banner/list',
        method: 'post',
        data
      })
    }
    export function bannerSave(data) {
      return request({
        url: '/admin/banner/save',
        method: 'post',
        data
      })
    }
    export function bannerDelete(data) {
      return request({
        url: '/admin/banner/delete',
        method: 'post',
        data
      })
    }
    export function bannerUpdate(data) {
      return request({
        url: '/admin/banner/update',
        method: 'post',
        data
      })
    }
    export function checkBnbHashId(data) {
      return request({
        url: '/admin/tronscanTransfer/checkBnbHashId',
        method: 'post',
        data
      })
    }
    // 充值优惠券配置
    export function couponList(data) {
      return request({
        url: '/admin/coupon/list',
        method: 'post',
        data
      })
    }
    export function couponSave(data) {
      return request({
        url: '/admin/coupon/save',
        method: 'post',
        data
      })
    }
    export function couponDelete(data) {
      return request({
        url: '/admin/coupon/delete',
        method: 'post',
        data
      })
    }
    export function couponUpdate(data) {
      return request({
        url: '/admin/coupon/update',
        method: 'post',
        data
      })
    }
    // 广告素材配置
    export function tieImageDetail(data) {
      return request({
        url: '/admin/tieImage/detail',
        method: 'post',
        data
      })
    }
    export function tieImageUpdate(data) {
      return request({
        url: '/admin/tieImage/update',
        method: 'post',
        data
      })
    }
    export function updateEtw(data) {
      return request({
        url: '/admin/member/updateEtw',
        method: 'post',
        data
      })
    }
    export function shareConfig(data) {
      return request({
        url: '/admin/shareConfig/view',
        method: 'post',
        data
      })
    }
    export function shareConfigUpdate(data) {
      return request({
        url: '/admin/shareConfig/update',
        method: 'post',
        data
      })
    }
    // 分享朋友圈记录
    export function memberTieList(data) {
      return request({
        url: '/admin/memberTie/list',
        method: 'post',
        data
      })
    }
    export function memberTiePass(data) {
      return request({
        url: '/admin/memberTie/pass',
        method: 'post',
        data
      })
    }
    export function memberTieReject(data) {
      return request({
        url: '/admin/memberTie/reject',
        method: 'post',
        data
      })
    }
    export function memberTiePassBatch(data) {
      return request({
        url: '/admin/memberTie/passBatch',
        method: 'post',
        data
      })
    }
    export function memberTieRejectBatch(data) {
      return request({
        url: '/admin/memberTie/rejectBatch',
        method: 'post',
        data
      })
    }
    // 成长学院
    export function xueYuanList(data) {
      return request({
        url: '/admin/commonStudy/list',
        method: 'post',
        data
      })
    }
    export function xueYuanSave(data) {
      return request({
        url: '/admin/commonStudy/save',
        method: 'post',
        data
      })
    }
    export function xueYuanUpdate(data) {
      return request({
        url: '/admin/commonStudy/update',
        method: 'post',
        data
      })
    }
    export function xueYuanDelete(data) {
      return request({
        url: '/admin/commonStudy/delete',
        method: 'post',
        data
      })
    }
    // 流水明细
    export function memberAmountRecordList(data) {
      return request({
        url: '/admin/memberAmountRecord/list',
        method: 'post',
        data
      })
    }
    export function subjectList(data) {
      return request({
        url: '/admin/memberAmountRecord/subjectList',
        method: 'post',
        data
      })
    }
    // 投资数据
    export function investDataList(data) {
      return request({
        url: '/admin/investData/list',
        method: 'post',
        data
      })
    }
    // 投资管理
    export function investList(data) {
      return request({
        url: '/admin/invest/list',
        method: 'post',
        data
      })
    }
    export function investSave(data) {
      return request({
        url: '/admin/invest/save',
        method: 'post',
        data
      })
    }
    export function investUpdate(data) {
      return request({
        url: '/admin/invest/update',
        method: 'post',
        data
      })
    }
    export function investDelete(data) {
      return request({
        url: '/admin/invest/delete',
        method: 'post',
        data
      })
    }
    // VIP等级管理
    export function vipConfigList(data) {
      return request({
        url: '/admin/vipConfig/list',
        method: 'post',
        data
      })
    }
    export function vipConfigSave(data) {
      return request({
        url: '/admin/vipConfig/save',
        method: 'post',
        data
      })
    }
    export function vipConfigUpdate(data) {
      return request({
        url: '/admin/vipConfig/update',
        method: 'post',
        data
      })
    }
    export function vipConfigDelete(data) {
      return request({
        url: '/admin/vipConfig/delete',
        method: 'post',
        data
      })
    }
    // 提现记录
    export function withdrawRecordList(data) {
      return request({
        url: '/admin/withdrawRecord/list',
        method: 'post',
        data
      })
    }
    export function totalAmount(data) {
      return request({
        url: '/admin/withdrawRecord/totalAmount',
        method: 'post',
        data
      })
    }
    export function autoShenhe(data) {
      return request({
        url: '/admin/withdrawRecord/autoShenhe',
        method: 'post',
        data
      })
    }
    export function updateAutoShenhe(data) {
      return request({
        url: '/admin/withdrawRecord/updateAutoShenhe',
        method: 'post',
        data
      })
    }
    export function applyCount(data) {
      return request({
        url: '/admin/withdrawRecord/applyCount',
        method: 'post',
        data
      })
    }
    export function checkSuccess(data) {
      return request({
        url: '/admin/withdrawRecord/checkSuccess',
        method: 'post',
        data
      })
    }
    export function checkReject(data) {
      return request({
        url: '/admin/withdrawRecord/checkReject',
        method: 'post',
        data
      })
    }
    export function checkSuccessList(data) {
      return request({
        url: '/admin/withdrawRecord/checkSuccessList',
        method: 'post',
        data
      })
    }
    export function checkRejectList(data) {
      return request({
        url: '/admin/withdrawRecord/checkRejectList',
        method: 'post',
        data
      })
    }
// 用户管理
export function memberList(data) {
  return request({
    url: '/admin/member/list',
    method: 'post',
    data
  })
}
export function setIsEnabled(data) {
  return request({
    url: '/admin/member/setIsEnabled',
    method: 'post',
    data
  })
}
export function setIsYewu(data) {
  return request({
    url: '/admin/member/setIsYewu',
    method: 'post',
    data
  })
}
export function updateIsLockVip(data) {
  return request({
    url: '/admin/member/updateIsLockVip',
    method: 'post',
    data
  })
}
export function updateIsTradeLevelx(data) {
  return request({
    url: '/admin/member/updateIsTradeLevelx',
    method: 'post',
    data
  })
}
export function updateVipLevel(data) {
  return request({
    url: '/admin/member/updateVipLevel',
    method: 'post',
    data
  })
}
export function updateMemo(data) {
  return request({
    url: '/admin/member/updateMemo',
    method: 'post',
    data
  })
}
export function updatePassword(data) {
  return request({
    url: '/admin/member/updatePassword',
    method: 'post',
    data
  })
}

export function updateWithdrawPassword(data) {
  return request({
    url: '/admin/member/updateWithdrawPassword',
    method: 'post',
    data
  })
}
export function viewSafeAddress(data) {
  return request({
    url: '/admin/member/viewSafeAddress',
    method: 'post',
    data
  })
}
export function updateSafeAddress(data) {
  return request({
    url: '/admin/member/updateSafeAddress',
    method: 'post',
    data
  })
}
export function memberPaa(data) {
  return request({
    url: '/admin/memberPaa/list',
    method: 'post',
    data
  })
}
export function chong(data) {
  return request({
    url: '/admin/member/chong',
    method: 'post',
    data
  })
}
export function amountList(data) {
  return request({
    url: '/admin/member/amountList',
    method: 'post',
    data
  })
}
export function ziAccountData(data) {
  return request({
    url: '/admin/yifangData/ziAccountData',
    method: 'post',
    data
  })
}
export function allChildrenSum(data) {
  return request({
    url: '/admin/member/allChildrenSum',
    method: 'post',
    data
  })
}
export function childrenSum(data) {
  return request({
    url: '/admin/member/childrenSum',
    method: 'post',
    data
  })
}
export function children(data) {
  return request({
    url: '/admin/member/children',
    method: 'post',
    data
  })
}
export function investRecordList(data) {
  return request({
    url: '/admin/investRecord/list',
    method: 'post',
    data
  })
}
export function tronscanValue(data) {
  return request({
    url: '/admin/common/syn',
    method: 'post',
    data
  })
}

export function tronscanTransferTrxList(data) {
  return request({
    url: '/admin/tronscanTransferTrx/list',
    method: 'post',
    data
  })
}
export function totalRechargeTrx(data) {
  return request({
    url: '/admin/tronscanTransferTrx/totalRecharge',
    method: 'post',
    data
  })
}
export function exportTrx(data) {
  return request({
    url: '/admin/tronscanTransferTrx/export',
    method: 'post',
    data
  })
}
// TRX提现记录
export function withdrawRecordTrxList(data) {
  return request({
    url: '/admin/withdrawRecordTrx/list',
    method: 'post',
    data
  })
}
export function checkSuccessTrx(data) {
  return request({
    url: '/admin/withdrawRecordTrx/checkSuccess',
    method: 'post',
    data
  })
}
export function checkRejectTrx(data) {
  return request({
    url: '/admin/withdrawRecordTrx/checkReject',
    method: 'post',
    data
  })
}
export function checkSuccessListTrx(data) {
  return request({
    url: '/admin/withdrawRecordTrx/checkSuccessList',
    method: 'post',
    data
  })
}
export function checkRejectListTrx(data) {
  return request({
    url: '/admin/withdrawRecordTrx/checkRejectList',
    method: 'post',
    data
  })
}
export function withdrawRecordTrxTotalAmount(data) {
  return request({
    url: '/admin/withdrawRecordTrx/totalAmount',
    method: 'post',
    data
  })
}
export function updateAutoShenheTrx(data) {
  return request({
    url: '/admin/withdrawRecordTrx/updateAutoShenhe',
    method: 'post',
    data
  })
}
export function autoShenheTrx(data) {
  return request({
    url: '/admin/withdrawRecordTrx/autoShenhe',
    method: 'post',
    data
  })
}
export function applyCountTrx(data) {
  return request({
    url: '/admin/withdrawRecordTrx/applyCount',
    method: 'post',
    data
  })
}
export function withdrawRecordTrxExport(data) {
  return request({
    url: '/admin/withdrawRecordTrx/export',
    method: 'post',
    data
  })
}
export function updateLockDate(data) {
  return request({
    url: '/admin/member/updateLockDate',
    method: 'post',
    data
  })
}
export function chongTrx(data) {
  return request({
    url: '/admin/member/chongTrx',
    method: 'post',
    data
  })
}

export function memberVipAwardList(data) {
  return request({
    url: '/admin/memberVipAward/list',
    method: 'post',
    data
  })
}
export function memberVipAwardAccept(data) {
  return request({
    url: '/admin/memberVipAward/accept',
    method: 'post',
    data
  })
}
export function memberVipAwardReject(data) {
  return request({
    url: '/admin/memberVipAward/reject',
    method: 'post',
    data
  })
}
export function jobContain(data) {
  return request({
    url: '/admin/common/jobContain',
    method: 'post',
    data
  })
}
export function updateChooseContain(data) {
  return request({
    url: '/admin/common/updateChooseContain',
    method: 'post',
    data
  })
}
export function unOpenSum(data) {
  return request({
    url: '/admin/tradeBuyRecordSum/unOpenSum',
    method: 'post',
    data
  })
}
export function allTicket(data) {
  return request({
    url: '/admin/tradeBuyRecordSum/allTicket',
    method: 'post',
    data
  })
}

export function memberShareRecordList(data) {
  return request({
    url: '/admin/memberShareRecord/list',
    method: 'post',
    data
  })
}
export function approveList(data) {
  return request({
    url: '/admin/memberShareRecord/approveList',
    method: 'post',
    data
  })
}
export function rejectList(data) {
  return request({
    url: '/admin/memberShareRecord/rejectList',
    method: 'post',
    data
  })
}
export function memberMeetingRecordList(data) {
  return request({
    url: '/admin/memberMeetingRecord/list',
    method: 'post',
    data
  })
}
export function memberMeetingRecordApproveList(data) {
  return request({
    url: '/admin/memberMeetingRecord/approveList',
    method: 'post',
    data
  })
}
export function memberMeetingRecordRejectList(data) {
  return request({
    url: '/admin/memberMeetingRecord/rejectList',
    method: 'post',
    data
  })
}
